import DataCollectionWizard from '../components/data-collection/DataCollectionWizard';
import AppFooter from '../components/ui/AppFooter';
import AppHeader from '../components/ui/AppHeader';

export default function DatenerhebungPage() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <AppHeader />
      <div style={{ flex: 1 }}>
        <DataCollectionWizard />
      </div>
      <AppFooter />
    </div>
  );
}
